import { PortNameBM } from 'src/types/BusinessModel/Stowage/Port/PortNameBM';
import { PortName } from 'src/types/ViewModel/Stowage/Port/PortName';

export const createPortName = (portNameBM: PortNameBM): PortName => {
    return {
        portId: portNameBM.portId,
        name: portNameBM.name,
        isDeleted: portNameBM.isDeleted,
        portClusterName: portNameBM.portClusterName || null,
    };
};

export const createPortNameList = (portNameBMList: PortNameBM[]) => portNameBMList.map((portName) => createPortName(portName));
